import React, { useState } from "react";
import { Tooltip, IconButton } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { tokens } from "../../theme/tokens";

const CopyButton: React.FC<{ value: string }> = ({ value }) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = (e: React.MouseEvent) => {
    e.stopPropagation();
    navigator.clipboard.writeText(value).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    });
  };

  return (
    <Tooltip title={copied ? "Copied!" : "Copy"} placement="top">
      <IconButton
        size="small"
        onClick={handleCopy}
        sx={{
          p: "2px",
          color: copied
            ? tokens.color.status.success
            : tokens.color.text.secondary,
          "&:hover": {
            color: copied
              ? tokens.color.status.success
              : tokens.color.text.primary,
          },
        }}
      >
        <ContentCopyIcon sx={{ fontSize: "13px" }} />
      </IconButton>
    </Tooltip>
  );
};

export default CopyButton;
